"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterDateTimeCell = void 0;
const instant_field_1 = require("../../../components/instant-field/instant-field");
const filter_interval_cell_factory_1 = require("./filter-interval-cell-factory");
/**
 * @deprecated
 *
 * Use FilterInstantCell instead.
 */
exports.FilterDateTimeCell = (0, filter_interval_cell_factory_1.filterIntervalCellFactory)(instant_field_1.InstantField);
//# sourceMappingURL=filter-date-time-cell.js.map